!function () {
  'use strict';

  const counterSelector = '[data-product-media-counter]';
  const currentSelector = '[data-product-media-counter-current]';
  const totalSelector = '[data-product-media-counter-total]';
  const mediaListSelector = '[data-product-media-list]';
  const slideSelector = '[data-slide]';
  const activeMediaAttr = 'data-active-media';
  const mobileSliderClass = 'product__images--mobile-slider';
  const mobileBreakpoint = 749;

  function getAllSlides(mediaList) {
    return [...mediaList.querySelectorAll(slideSelector)].filter((slide) => {
      if (slide.hasAttribute('hidden')) return false;
      return window.getComputedStyle(slide).display !== 'none';
    });
  }

  function updateFromScroll(mediaList, currentEl) {
    const slides = getAllSlides(mediaList);
    if (!slides.length) return;

    const scrollLeft = mediaList.scrollLeft;
    let bestIndex = 0;
    let bestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    currentEl.textContent = String(bestIndex + 1);
  }

  function updateFromActive(productImages, mediaList, currentEl) {
    const slides = getAllSlides(mediaList);
    const activeId = productImages.getAttribute(activeMediaAttr);
    const activeIndex = slides.findIndex((slide) => slide.getAttribute('data-media-id') === activeId);

    currentEl.textContent = String(activeIndex >= 0 ? activeIndex + 1 : 1);
  }

  function isMobileSliderMode(productImages) {
    return (
      window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches &&
      productImages.classList.contains(mobileSliderClass)
    );
  }

  function initMediaCounter(productImages) {
    const counter = productImages.querySelector(counterSelector);
    if (!counter || counter.dataset.mediaCounterBound === 'true') return;

    const currentEl = counter.querySelector(currentSelector);
    const totalEl = counter.querySelector(totalSelector);
    const mediaList = productImages.querySelector(mediaListSelector);

    if (!currentEl || !totalEl || !mediaList) return;

    counter.dataset.mediaCounterBound = 'true';

    let intersectionObserver = null;

    const teardownIntersectionObserver = () => {
      if (!intersectionObserver) return;
      intersectionObserver.disconnect();
      intersectionObserver = null;
    };

    const setupIntersectionObserver = () => {
      teardownIntersectionObserver();

      if (!isMobileSliderMode(productImages)) return;

      const slides = getAllSlides(mediaList);
      if (!slides.length) return;

      intersectionObserver = new IntersectionObserver(
        (entries) => {
          let bestEntry = null;

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
              bestEntry = entry;
            }
          });

          if (!bestEntry) return;

          const slides = getAllSlides(mediaList);
          const index = slides.indexOf(bestEntry.target);
          if (index >= 0) {
            currentEl.textContent = String(index + 1);
          }
        },
        {
          root: mediaList,
          threshold: [0.35, 0.5, 0.65, 0.8, 1],
        }
      );

      slides.forEach((slide) => intersectionObserver.observe(slide));
    };

    const updateTotal = () => {
      const count = getAllSlides(mediaList).length;
      totalEl.textContent = String(count);
      counter.hidden = count <= 1;
    };

    const update = () => {
      updateTotal();
      setupIntersectionObserver();

      if (isMobileSliderMode(productImages)) {
        updateFromScroll(mediaList, currentEl);
      } else {
        updateFromActive(productImages, mediaList, currentEl);
      }
    };

    let scrollTicking = false;

    mediaList.addEventListener(
      'scroll',
      () => {
        if (!isMobileSliderMode(productImages)) return;
        if (scrollTicking) return;

        scrollTicking = true;
        requestAnimationFrame(() => {
          scrollTicking = false;
          updateFromScroll(mediaList, currentEl);
        });
      },
      { passive: true }
    );

    const observer = new MutationObserver(update);
    observer.observe(productImages, { attributes: true, attributeFilter: [activeMediaAttr] });
    observer.observe(mediaList, { attributes: true, attributeFilter: ['class', 'hidden'], subtree: true });

    document.addEventListener('theme:resize:width', update);
    update();
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll('product-images').forEach(initMediaCounter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
}();
